export default "__VITE_ASSET__b88fbdf9__"